import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ReportServices } from "../../scripts/ah.mb.report-services";
import { IDownloadReportsModel } from "../../entities/download-reports-model";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";

@Component
export default class DownloadReportsDialog extends Vue {

    @Prop()
    reportServices: ReportServices;

    @Prop()
    value: IDownloadReportsModel;

    // Create user notifier
    private userNotifier = new ClientNotifier();


    onDownloadClick() {
        // Todo: make sure can download multiple reports

        this.userNotifier.showNotification(`Preparing report download, please wait...`, true, false);

        switch (this.value.mode) {
            case "byReportDefinition":
                this.reportServices.downloadReports(
                    this.value.modelId,
                    this.value.reportNodePathAndNames,
                    this.value.format,
                    this.value.createPivots,
                    this.value.singleSheet,
                    this.value.recursive)
                    .then(() => {
                        this.$emit("dialogClosed", "ok");
                    });
                break;

            case "bySubjectNode":
                this.reportServices.downloadReportsByNode(
                    this.value.modelId,
                    this.value.reportNodePathAndNames,
                    this.value.reportNames,
                    this.value.format,
                    this.value.createPivots)
                    .then(() => {
                        this.$emit("dialogClosed", "ok");
                    }
                    );

                break;

            case "byRecordStream":
                this.reportServices.downloadModelRecordsStream(
                    this.value.modelId,
                    "Report Results",
                    this.value.reportNodePathAndNames,
                    this.value.recordSetName,
                    this.value.format,
                    this.value.reportNames)
                    .then(() => {
                        this.$emit("dialogClosed", "ok");
                    });

                break;

            case "byRecordExportDefinition":
                this.reportServices.downloadModelRecordsStreamByDefinition(
                    this.value.modelId,
                    this.value.definitionNodePathAndName,
                    this.value.format,
                    this.value.reportNodePathAndNames)
                    .then(() => {
                        this.$emit("dialogClosed", "ok");
                    });

                break;

        }
    }

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/download-reports-dialog/download-reports-dialog.ts